// import variables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings'
// console.log(variables);

const { title, showSettings, tagsView, fixedHeader, sidebarLogo, supportPinyinSearch } = defaultSettings

const state = {
    // theme: variables.theme,
    theme: '#1890ff',
    title: getTitle(),
    showSettings,
    tagsView,
    fixedHeader,
    sidebarLogo,
    supportPinyinSearch
}

export function getTitle() {
    const UserType = localStorage.getItem('UserType')
    if (UserType === 'enterprise') {
        return '云控系统企业版'
    }
    return title
}

const mutations = {
    CHANGE_SETTING: (state, { key, value }) => {
        // eslint-disable-next-line no-prototype-builtins
        if (state.hasOwnProperty(key)) {
            state[key] = value
        }
    }
}

const actions = {
    changeSetting({ commit }, data) {
        commit('CHANGE_SETTING', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

